import { APP_INITIALIZER, ErrorHandler, NgModule, OnInit } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy, Router } from '@angular/router';
import { AuthInterceptor } from './services/auth.interceptor';
import { UrlPathInterceptor } from './services/urlPath.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ComponentsModule } from './components/components.module';
import { TeacherProvider } from './providers/teacher/teacher.provider';
import { ResourcesProvider } from './providers/resources/resources.provider';
import { PagesProvider } from './providers/pages/pages.provider';
import { ArticlesProvider } from './providers/articles/articles.provider';
import { PreferencesProvider } from './providers/preferences/preferences.provider';
import { AccountProvider } from './providers/account/account';
import { AudioProvider } from './providers/audio/audio.provider';
import { UpdateProvider } from './providers/update/update.provider';
import { StateProvider } from './providers/state/state.provider';

// import { DataSyncService } from './services/sync.service';

import { Common } from './lib/common';

import { CssUtilitiesService } from './services/css/css-utilities.service'
import { WindowService } from './services/window.service'
import { ResourcesCssService } from './pages/resources/resources-css.service';
import { UnsupportedBrowserComponent } from './pages/unsupported-browser/unsupported-browser.component'
import { DragulaModule } from 'ng2-dragula'
import { EventService } from './services/event.service';

import { IonicStorageModule } from '@ionic/storage-angular';
import { Storage } from '@ionic/storage';
// import { StorageService } from './services/storage.service';
import { UserStore } from './stores/user.store';
import { TeacherStore } from './stores/teacher.store';
import { ResourceStore } from './stores/resources.store';
import { StorageService } from './services/storage.service';
import { DataSyncService } from './services/sync.service';

import * as Sentry from "@sentry/angular-ivy";


@NgModule({
  declarations: [
    AppComponent,
    UnsupportedBrowserComponent
  ],
  // entryComponents: [

  // ],
  imports: [
    BrowserModule,
    IonicModule.forRoot({
      mode: 'md'
    }),
    AppRoutingModule,
    ComponentsModule,
    IonicStorageModule.forRoot(),
    HttpClientModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled : environment.production || true }),
    DragulaModule.forRoot()
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: UrlPathInterceptor, multi: true },
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler({ showDialog: false })},
    { provide: Sentry.TraceService, deps: [Router] },
    { provide: APP_INITIALIZER, useFactory: () => () => {}, deps: [Sentry.TraceService], multi: true },
    TeacherProvider,
    ResourcesProvider,
    PagesProvider,
    ArticlesProvider,
    PreferencesProvider,
    AccountProvider,
    AudioProvider,
    UpdateProvider,
    StateProvider,
    DataSyncService,
    EventService,
    StorageService,
    Common,
    CssUtilitiesService,
    WindowService,
    ResourcesCssService,
    CookieService,
    UserStore,
    TeacherStore,
    ResourceStore,
    Storage
  ],
  bootstrap: [AppComponent]
})
export class AppModule {  
  constructor(private stateProvider: StateProvider,
              private storageService: StorageService,
              private sync: DataSyncService,
              private storage: Storage) {

  }

}
